import { axiosGet, axiosPost, axiosPut } from "../axois_V2/axoisWithAuthV2";
import { throwError } from "../utils/error";

export const campaignBaseURL_V2 = "/campaign/v2";

export interface CreateCampaignPayload {
  name: string;
  startDate: string;
  endDate: string;
  tagline: string;
  description: string;
  cities: string[];
  ngos: string[];
}

export interface BulkCampaignInvitePayload {
  memberIds: string[];
  campaignId: string;
}

export interface GetCampaignsPayload {
  page?: number;
  limit?: number;
  search?: string;
  showOrgCampaigns?: boolean;
}

export const getAllCampaign_V2 = async (payload?: GetCampaignsPayload) => {
  try {
    let url = `${campaignBaseURL_V2}`;
    if (payload) {
      const queryParams = new URLSearchParams();
      if (payload.page) queryParams.append("page", payload.page.toString());
      if (payload.limit) queryParams.append("limit", payload.limit.toString());
      if (payload.search) queryParams.append("search", payload.search);
      if (payload.showOrgCampaigns) queryParams.append("showOrgCampaigns", payload.showOrgCampaigns.toString());
      url += `?${queryParams.toString()}`;
    }
    const res = await axiosGet(url);
    return res;
  } catch (error) {
    throwError(error);
  }
};

export const createCampaign_V2 = async (payload: FormData) => {
  try {
    const res = await axiosPost(`${campaignBaseURL_V2}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res;
  } catch (error) {
    throwError(error);
  }
};

export const getCampaignById_V2 = async (campaignId: string) => {
  try {
    const res = await axiosGet(`${campaignBaseURL_V2}/${campaignId}`);
    return res;
  } catch (error) {
    throwError(error);
  }
};

export const getNgosByCampaignAndCity_V2 = async (campaignId: string, cityId: string) => {
  try {
    const res = await axiosGet(`${campaignBaseURL_V2}/${campaignId}/cities/${cityId}/ngos`);
    return res;
  } catch (error) {
    throwError(error);
  }
};

export const uploadCampaignImage_V2 = async (
  campaignId: string,
  payload: FormData
) => {
  try {
    return await axiosPut(
      `${campaignBaseURL_V2}/update-image/${campaignId}`,
      payload
    );
  } catch (error) {
    throwError(error);
  }
};

export const updateCampaign_V2 = async (
  campaignId: string,
  payload: any,
) => {
  try {
    const res = await axiosPut(
      `${campaignBaseURL_V2}/${campaignId}`,
      payload
    );
    return res;
  } catch (error) {
    throwError(error);
  }
}

export const sendBulkCampaignInvite = async (
  payload: BulkCampaignInvitePayload
) => {
  try {
    const res = await axiosPost(`${campaignBaseURL_V2}/bulk-invite`, payload);
    return res
  } catch (error) {
    throwError(error);
  }
};




